module.exports = __webpack_public_path__ + "355CC9_2_0.woff?204a04712717a5f1083b7100e12fb30e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_2_0.woff
// module id = 38
// module chunks = 0